import { store } from "@/store/index"

const redactedEmail = email => {
  if (!email) return ""
  const [localPart, domain] = email.split("@")
  const redactedLocalPart =
    localPart.charAt(0) + "***" + localPart.charAt(localPart.length - 1)
  return `${redactedLocalPart}@${domain}`
}

export const loggerCallBack = ({
  logger = () => {},
  message = "",
  action = "",
  data = {},
}) => {
  const { auth: { user: { lowercaseEmail = "" } = {}, isAuth = false } = {} } =
    store.getState()

  const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token")
  let oktaObject = {}
  try {
    oktaObject = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {}
  } catch (e) {
    console.warn("Anonymous Okta Token can not be decoded......", e.message)
    oktaObject = {}
  }

  const objectId = oktaObject?.gId || ""

  const email = redactedEmail(lowercaseEmail)
  const logDetails = isAuth
    ? { ...data, user: email }
    : { ...data, guestID: objectId } || {}

  switch (action.toLocaleLowerCase()) {
    case "error":
      logger?.error(message, logDetails)
      break
    case "info":
      logger?.info(message, logDetails)
      break
    case "warn":
      logger?.warn(message, logDetails)
      break
    default:
      logger?.log(message, logDetails)
      break
  }
}
